export const SAVE_BOOK_REQUEST = "SAVE_BOOK_REQUEST";
export const FETCH_BOOK_REQUEST = "FETCH_BOOK_REQUEST";
export const UPDATE_BOOK_REQUEST = "UPDATE_BOOK_REQUEST";
export const DELETE_BOOK_REQUEST = "DELETE_BOOK_REQUEST";
export const BOOK_SUCCESS = "BOOK_SUCCESS";
export const BOOK_FAILURE = "BOOK_FAILURE";

export const FETCH_LANGUAGES_REQUEST = "FETCH_LANGUAGES_REQUEST";
export const LANGUAGES_SUCCESS = "LANGUAGES_SUCCESS";
export const LANGUAGES_FAILURE = "LANGUAGES_FAILURE";

export const FETCH_GENRES_REQUEST = "FETCH_GENRES_REQUEST";
export const GENRES_SUCCESS = "GENRES_SUCCESS";
export const GENRES_FAILURE = "GENRES_FAILURE";
